<template>
  <div class="container">
    <photo-preview ref="photoPreview">
      <van-col span="6" class="share-icon" @click="hanldeSupport">
        <van-icon name="good-job" />
        <div>点赞</div>
      </van-col>
    </photo-preview>
  </div>
</template>

<script>
import PhotoPreview from './components/photo-preview'
import extraStyleApi from '@/api/extra-style'
import { sessionStorageUtils } from '@/utils/sessionstorage'
export default {
  name: 'ExtraStylePhotoSupport',
  components: {
    PhotoPreview
  },
  created () {
    // this.initWx()
  },
  data () {
    return {
    }
  },
  methods: {
    // initWx () {
    //   const authCode = this.$route.query.code || ''
    //   alert('authCode', authCode)
    //   if (authCode) {
    //     wxApi.getAuthInfo(authCode).then(response => {
    //       if (response.data.resultCode === '0') {
    //         this.wxUserInfo = response.data.resultData.wxUserInfo
    //       } else {
    //         this.$router.push({ name: 'home' })
    //       }
    //     }).catch(() => {
    //       this.$router.push({ name: 'home' })
    //     })
    //   } else {
    //     const curUrl = commonUtils.getCurrentUrl()
    //     const wxAuthUrl = commonUtils.getWxAuthUrl(curUrl)
    //     alert(wxAuthUrl)
    //     document.location = wxAuthUrl
    //   }
    // },
    hanldeSupport () {
      const wxUserInfo = sessionStorageUtils.get('wxUserInfo') || ''
      if (!wxUserInfo) {
        this.$notify({ type: 'danger', message: '点赞失败' })
        return
      }
      const data = {
        photoId: this.$route.query.photoId || '',
        wxOpenId: wxUserInfo.openId || ''
      }
      extraStyleApi.supportExtraStylePhoto(data).then(response => {
        if (response.data.resultCode === '0') {
          this.$notify({ type: 'success', message: '点赞成功' })
          this.$refs.photoPreview.queryExtraStylePhotoDetail()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  position: relative;
  .share-icon {
    padding-top: 10px;
    font-size: 40px;
    color: #22545b;
    div {
      font-size: 18px;
    }
  }
}
</style>
